import type { CurrencySettings } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { isNullish } from '@eliadmin/core/src/utils/misc-utils';

export function roundPrice(price: number | string, rounding: number = 2) {
  if (price === 0) return 0;
  const temp = typeof price === 'string' ? parseFloat(price) : price;
  if (!rounding) return temp;
  const power = Math.pow(10, rounding);
  return Math.round(temp * power) / power;
}

export function formatPrice(
  price: number | string | undefined,
  currency: string,
  currency_settings: CurrencySettings | null = null,
  rounding = true,
  custom_quantity = 1,
  add_after_custom_quantity = 0,
) {
  if (isNullish(price)) return '';
  const temp =
    typeof price === 'string'
      ? parseFloat(price) * custom_quantity + add_after_custom_quantity
      : price * custom_quantity + add_after_custom_quantity;
  let roundedPrice: number | string = rounding
    ? roundPrice(temp, Number(currency_settings?.rounding))
    : temp;

  const decimalPlaces = currency_settings?.decimal_places;
  if (!isNullish(decimalPlaces) && !isNaN(Number(decimalPlaces))) {
    roundedPrice = Number(roundedPrice).toFixed(Number(decimalPlaces));
  }

  const parts = roundedPrice.toString().split('.');
  const decimalPart = parts[1];
  let numberPart = parts[0];

  const separatorValue = currency_settings?.separator;
  const separatorSize =
    !isNullish(separatorValue) && !isNaN(Number(separatorValue)) ? Number(separatorValue) : 3;
  const separatorUnit = currency_settings?.separator_unit;
  const thousandsSeparator =
    !isNullish(separatorUnit) && !isNaN(Number(separatorUnit))
      ? String.fromCharCode(Number(separatorUnit))
      : ' ';

  if (separatorSize > 0) {
    const thousands = new RegExp(`\\B(?=(\\d{${separatorSize}})+(?!\\d))`, 'g');
    numberPart = numberPart.replace(thousands, thousandsSeparator);
  }

  const decimalPoint = currency_settings?.decimal_point ?? ',';
  const formattedPrice = `${numberPart}${decimalPart ? decimalPoint + decimalPart : ''}`;

  if (currency_settings?.symbol_position === false) {
    return `${currency} ${formattedPrice}`;
  }

  return `${formattedPrice} ${currency}`;
}

export function computePriceWithDiscount(price: number, discount: number) {
  return price - (price * discount) / 100;
}

export function computePriceBeforeDiscount(price: number, discount: number) {
  return price / (1 - discount / 100);
}

export function roundTo(value: number, places: number = 2) {
  const power = Math.pow(10, places);
  return Math.round(value * power) / power;
}
